module.exports = __webpack_public_path__ + "static/schwarz-optik-header-f17b231d6d7482221a8f95c225faa808.jpg";